import { render, staticRenderFns } from "./MemberDesignation.vue?vue&type=template&id=bd9ee6a8"
import script from "./MemberDesignation.vue?vue&type=script&lang=js"
export * from "./MemberDesignation.vue?vue&type=script&lang=js"
import style0 from "./MemberDesignation.vue?vue&type=style&index=0&id=bd9ee6a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports